import { create, useStore } from 'zustand';

interface CollateralFormStore {
  isEditing: Set<string>;
  localOnly: Set<string>;

  actions: {
    setIsEditing(args: {
      id: string;
      isEditing: boolean;
      localOnly?: boolean;
    }): void;
    stopEditingAll(): void;
  };
}

const createCollateralFormStore = () =>
  create<CollateralFormStore>((set) => ({
    isEditing: new Set(),
    localOnly: new Set(),
    actions: {
      setIsEditing({ id, isEditing, localOnly = false }) {
        set((state) => {
          const newIsEditing = new Set(state.isEditing);
          const newLocalOnly = new Set(state.localOnly);

          if (isEditing) {
            newIsEditing.add(id);
            if (localOnly) newLocalOnly.add(id);
          } else {
            newIsEditing.delete(id);
            newLocalOnly.delete(id);
          }

          return { isEditing: newIsEditing, localOnly: newLocalOnly };
        });
      },

      stopEditingAll() {
        set(() => ({ isEditing: new Set(), localOnly: new Set() }));
      },
    },
  }));

const collateralFormStores: Record<
  string,
  ReturnType<typeof createCollateralFormStore>
> = {};

export function getCollateralFormStore(applicationID: string) {
  if (!collateralFormStores[applicationID])
    collateralFormStores[applicationID] = createCollateralFormStore();

  return collateralFormStores[applicationID];
}

export function useCollateralFormStore(applicationID: string) {
  return useStore(getCollateralFormStore(applicationID));
}

export function useCollateralFormStoreActions(applicationID: string) {
  return useStore(getCollateralFormStore(applicationID), (x) => x.actions);
}
